var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "#E7EBF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 29C22.732 29 29 22.732 29 15C29 7.26801 22.732 1 15 1C7.26801 1 1 7.26801 1 15C1 22.732 7.26801 29 15 29Z",
    fill: "#E7EBF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6855 7.5859H17.2056V6H12.48V7.5859H9V10.0899H20.6855V7.5859ZM13.732 7.25202H15.9536V7.5859H13.732V7.25202Z",
    fill: "#FF5151"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5719 14.9439L19.8081 11.3418H9.87402L10.6676 23.4447H15.4325C14.8123 22.5655 14.4475 21.4938 14.4475 20.3384C14.4475 17.4529 16.7218 15.0886 19.5719 14.9439Z",
    fill: "#FF5151"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8508 16.1895C17.5627 16.1895 15.7012 18.051 15.7012 20.339C15.7012 22.6271 17.5627 24.4887 19.8508 24.4887C22.1389 24.4887 24.0004 22.6271 24.0004 20.339C24.0004 18.0509 22.1389 16.1895 19.8508 16.1895ZM22.1118 21.7147L21.2265 22.6L19.8508 21.2243L18.4751 22.6L17.5898 21.7147L18.9655 20.339L17.5898 18.9634L18.4751 18.078L19.8508 19.4537L21.2265 18.078L22.1118 18.9634L20.7361 20.339L22.1118 21.7147Z",
    fill: "#FF5151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "res/media/delete.1dd9cd0cf267e3bd7e48a6a75d7f7db7.svg";
export { ForwardRef as ReactComponent };